import { appState, gameState, scoreConfig } from "./state.js";

export function addScore(amount) {
  const value = Number(amount);
  if (!Number.isFinite(value) || value <= 0) {
    return;
  }
  gameState.score += value;
  appState.requestDraw?.();
}

export function addBlueScore(amount) {
  const value = Number(amount);
  if (!Number.isFinite(value) || value <= 0) {
    return;
  }
  gameState.blueScore += value;
  appState.requestDraw?.();
}

export function getScoreConfigSnapshot() {
  return {
    yut: scoreConfig.yut,
    mo: scoreConfig.mo,
    do: scoreConfig.do,
    gae: scoreConfig.gae,
    geol: scoreConfig.geol,
    capture: scoreConfig.capture,
    goal: scoreConfig.goal,
    goal2: scoreConfig.goal2,
    goal3: scoreConfig.goal3,
    goal4: scoreConfig.goal4,
    blueGoal: scoreConfig.blueGoal,
    blueGoal2: scoreConfig.blueGoal2,
    blueGoal3: scoreConfig.blueGoal3,
    blueGoal4: scoreConfig.blueGoal4,
    win: scoreConfig.win,
  };
}

export function applyScoreConfig(values) {
  for (const key of Object.keys(scoreConfig)) {
    const next = Number(values[key]);
    if (Number.isFinite(next)) {
      scoreConfig[key] = Math.max(0, next);
    }
  }
}

export function getScoreAverage() {
  const values = Object.values(scoreConfig);
  const total = values.reduce((sum, value) => sum + (Number(value) || 0), 0);
  return values.length ? total / values.length : 0;
}
